module.exports = __webpack_public_path__ + "media/images/icons/twotone/question-circle-e25e0f747dc7ee3dce293fd10cead730.svg";